import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { encrypt , decrypt , getParams } from "../../helpers/CryptoJs";
import PromotionComponent from "../../components/Promotion";
import Chatbar from "../../components/Chatbar";

class Promotion extends Component {
  constructor(props){
    super(props);
    this.state = {
        promotionId  : (this.props.match.params.id !== undefined) ? decrypt(this.props.match.params.id) : 0,
        page         : null
    };
    
  }
  shouldComponentUpdate(nextProps, prevProps, prevState) {
    return true;
  }
  componentDidUpdate(prevProps, prevState) {
    const { pathname } = this.props.location;
    const { pathname: prevPathname } = prevProps.location;
    const type = `/album/:id`;
    const currentParams = getParams(pathname , type);
    const prevParams = getParams(prevPathname , type);
    if (currentParams.id && currentParams.id !== prevParams.id) {
      this.setState({
        userId: decrypt(currentParams.id),
      });
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('body').classList.remove('login_page');
    let href = window.location.href;
    let page = href.includes('promotion_create');
    if( href.includes('promotion_create') == true){
      this.setState({
        page : 'create',
      });
    }else if( href.includes('promotion_preview') == true){
      this.setState({
        page : 'preview',
      });
    }
  }
  render() {
   
    return (
      <div className="wrapper">
        <Header/>
        <Sidebar/>
        <PromotionComponent pagename = {this.state.page} promotionId={this.state.promotionId}/>
        <Chatbar />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
  
  }
}
const mapDispatchToProps = dispatch => {
  return {
    
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Promotion));